<template>
  <v-container id="regular-tables" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              Action
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/ticket/create'">
            <v-list-item-title>Create</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card color="cyan" icon="mdi-filter" class="px-5 py-1" v-if="showFilter">
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <z-date-picker v-model="filterDate" />
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field :label="$i18n.t('Ticket No')" class="purple-input" v-model="ticketNo" />
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                :items="types"
                :label="$i18n.t('Ticket Type')"
                class="purple-input"
                v-model="type"
              ></v-select>
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                :items="statuses"
                :label="$i18n.t('Status')"
                class="purple-input"
                v-model="status"
              ></v-select>
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                :items="priorities"
                :label="$i18n.t('Priority')"
                class="purple-input"
                v-model="priority"
              ></v-select>
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-btn
                class="mr-0"
                color="grey darken"
                fab
                text
                small
                @click="clear(1)"
                style="margin-right:10px !important"
              >
                <v-icon>mdi-cached</v-icon>
              </v-btn>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-ticket"
      title="Tickets"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
      color="primary"
    >
      <v-simple-table dense>
        <thead>
          <tr>
            <th class="primary--text">Ticket No</th>
            <th class="primary--text">Ticket Kind</th>
            <th class="primary--text">Subject</th>
            <th class="primary--text">Raised By</th>
            <th class="primary--text">Created At</th>
            <th class="primary--text">Priority</th>
            <th class="primary--text">Status</th>
            <th class="text-right primary--text">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="ticket in grid.rows" :key="ticket._id">
            <td>{{ ticket.ticketNo }}</td>
            <td>
              <span
                v-if="
                  (ticket.kind == 10 && ticket.subKind == 11) ||
                    (ticket.kind == 20 && ticket.subKind == 21)
                "
              >{{ $i18n.t("Enhancement") }}</span>
              <span
                v-if="
                  (ticket.kind == 10 && ticket.subKind == 12) ||
                    (ticket.kind == 20 && ticket.subKind == 22)
                "
              >{{ $i18n.t("Bug") }}</span>
              <span v-if="ticket.kind == 10 && ticket.subKind == 13">
                {{
                $i18n.t("Data Correction")
                }}
              </span>
              <span v-if="ticket.kind == 10 && ticket.subKind == 14">
                {{
                $i18n.t("New Master")
                }}
              </span>
            </td>
            <td>{{ ticket.header }}</td>
            <td>{{ ticket.raisedBy }}</td>
            <td>{{ ticket.createdAt | moment("DD-MMM-YY") }}</td>
            <td>
              <span v-if="ticket.priority == 1">{{ $i18n.t("Low") }}</span>
              <span v-if="ticket.priority == 2">{{ $i18n.t("Medium") }}</span>
              <span v-if="ticket.priority == 3">{{ $i18n.t("High") }}</span>
              <span v-if="ticket.priority == 4">{{ $i18n.t("Critical") }}</span>
            </td>

            <td>
              <span v-if="ticket.status == 0">{{ $i18n.t("Open") }}</span>
              <span v-if="ticket.status == 1">{{ $i18n.t("In Progress") }}</span>
              <span v-if="ticket.status == 2">{{ $i18n.t("Closed") }}</span>
              <span v-if="ticket.status == 3">{{ $i18n.t("Rejected") }}</span>
              <span v-if="ticket.status == 4">
                {{
                $i18n.t("Client Input Required")
                }}
              </span>
            </td>
            <td>
              <v-btn
                class="float-right"
                color="primary"
                small
                fab
                text
                dark
                :to="'/ticket/' + ticket._id"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <div class="py-3" />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  grid = {};
  url = "/api/ticket/grid?sidx=status&sord=asc&rows=30";
  showFilter = false;
  filterDate = null;
  menu1 = false;
  filterUrl = "";
  ticketNo = "";
  priority = "";
  status = "";
  type = "";

  types = [
    {
      text: "For Web",
      value: 10,
    },
    {
      text: "For App",
      value: 20,
    },
  ];

  priorities = [
    {
      text: "Low",
      value: 1,
    },
    {
      text: "Medium",
      value: 2,
    },
    {
      text: "High",
      value: 3,
    },
    {
      text: "Critical",
      value: 4,
    },
  ];

  statuses = [
    {
      text: "Open",
      value: 0,
    },
    {
      text: "In Progress",
      value: 1,
    },
    {
      text: "Closed",
      value: 2,
    },
    {
      text: "Rejected",
      value: 3,
    },
    {
      text: "Client Input Required",
      value: 4,
    },
  ];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.dateFormatted = null;
    this.date = null;
    this.filterDate = "";
    this.ticketNo = "";
    this.priority = "";
    this.status = "";
    this.type = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filterDate) this.filterUrl += "&date=" + this.filterDate;
    if (this.ticketNo) this.filterUrl += "&ticketNo=" + this.ticketNo;
    if (this.priority) this.filterUrl += "&priority=" + this.priority;
    if (this.status) this.filterUrl += "&status=" + this.status;
    if (this.type) this.filterUrl += "&kind=" + this.type;
    common.setLoading(true);
    this.showPage(1);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>
